import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * PrivateRoute - Protège les routes selon l'authentification et le rôle.
 * @param {string} role - Rôle requis ('ADMIN', 'PROF', 'PARENT')
 */
const PrivateRoute = ({ children, role }) => {
    const { isAuthenticated, user } = useAuth();
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (role && user?.role !== role) {
        // Rediriger vers l'espace correspondant au rôle réel
        const redirectMap = { ADMIN: '/admin', PROF: '/prof', PARENT: '/parent' };
        return <Navigate to={redirectMap[user.role] || '/login'} replace />;
    }

    return children;
};

export default PrivateRoute;
